<script>
import { componentStore } from "@common/componentStore/componentStore";
import { ddStore } from "@common/ddStore";
import { library } from "@common/library/library";
import { actionStore } from "@common/actionStore";

const pdfTemplateManagerConfig = {
    cId: "pdfTemplateManager",
    cType: "pdfTemplateManager",
    cTitle: "PDF Templates",
    cTemplate: `<div class="pdf-template-manager">
                    <div v-if="surveysExist">
                        * indicates Surveys with "Can be used as PDF Template" option checked.
                    </div>
                    <grid
                        :c-id="selectedPdfTemplateId"
                        ref="pdfTemplatesGrid"
                        @update:data-bound="selectPrevious($event)"
                        :prop-data="templateList"
                        :prop-settings="gridSettings"
                        :prop-selected-items="selectedItems"
                        :prop-dbl-click-fnc="dblClickFnc"
                        @update:prop-selected-items="selectedItems = $event;"
                        :prop-selected-items-full-data="selectedItemsFullData"
                        @update:prop-selected-items-full-data="selectedItemsFullData = $event; disableButtons()"
                    ></grid>

                    <div class="template-controls">
                        <div class="left-controls">
                            <control name="NEW_TEMPLATE"></control>
                            <control name="COPY_TEMPLATE"></control>
                        </div>
                        <div class="right-controls">
                            <control name="EDIT_TEMPLATE"></control>
                            <control name="DELETE_TEMPLATE"></control>
                            <control name="DOWNLOAD_TEMPLATE"></control>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'NEW_TEMPLATE',
            type: 'button',
            label: 'New',
            onclick: 'new'
        },
        {
            name: 'EDIT_TEMPLATE',
            type: 'button',
            label: 'Edit',
            onclick: 'edit',
            disabled: true
        },
        {
            name: 'DELETE_TEMPLATE',
            type: 'button',
            label: 'Delete',
            onclick: 'delete',
            disabled: true
        },
        {
            name: 'COPY_TEMPLATE',
            type: 'button',
            label: 'Copy',
            onclick: 'copy',
            disabled: true
        },
        {
            name: 'DOWNLOAD_TEMPLATE',
            type: 'button',
            label: 'Download',
            onclick: 'download',
            disabled: true
        },
    ]
};

let pdfTemplateManagerCmp = {
    name: 'pdfTemplateManager',
    props: {
    },
    data() {
        return {
            selectedTemplate: null,
            templateList: {},
            selectedItems: {},
            selectedItemsFullData: {},
            gridSettings: {
                "paging": true,
                "sorting": false,
                "filtering": false,
                "grouping": false,
                "width": '100%',
                "height": '310px',
                "enableCheckBox": true,
                "clipMode": "EllipsisWithTooltip",
                "pageSettings": {
                    "pageSize": 10,
                    "pageCount": 1
                },
            },
            prevSelected: [],
            surveysExist: false
        };
    },
    computed: {
        selectedPdfTemplateId() {
            return this.config.selectedPdfTemplateId || 'grid_pdf_templates';
        },

    },
    methods: {
        async onLoad() {
            ddStore.preloadGroup('COMMON');
            this.getList();
        },
        selectPrevious(isPreparingData) {
            this.$nextTick(() => {
                let prevSelectedIndexes = [];
                if (this.prevSelected.length && this.templateList && this.templateList.records && this.templateList.records.length) {
                    for (let i in this.prevSelected) {
                        if (i === 'length') continue;
                        let tmpIndex = this.templateList.records.findIndex((elm) => elm.ATTACH_ID === this.prevSelected[i].ATTACH_ID);
                        if (parseInt(tmpIndex, 10) >= 0) {
                            prevSelectedIndexes.push(tmpIndex);
                        }
                    }
                }
                if (prevSelectedIndexes.length
                    && this.$refs
                    && this.$refs['pdfTemplatesGrid']
                    && this.$refs['pdfTemplatesGrid'].$refs
                    && this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates']
                    && this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates'].ej2Instances
                    && typeof this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates'].ej2Instances.selectRows === 'function'
                ) {
                    this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates'].ej2Instances.selectRows(prevSelectedIndexes);
                }
                this.disableButtons();
            });
        },
        async getList() {
            if (this.$refs
                && this.$refs['pdfTemplatesGrid']
                && this.$refs['pdfTemplatesGrid'].$refs
                && this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates']
                && this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates'].ej2Instances
                && typeof this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates'].ej2Instances.getSelectedRecords === 'function'
            ) {
                this.prevSelected = this.$refs['pdfTemplatesGrid'].$refs['grid_pdf_templates'].ej2Instances.getSelectedRecords();
            }
            this.templateList = {};
            this.showLoadingIndicator();
            let response = await this.sDs.post('sds_getPdfTemplateList', { sDsParams: { force: true } });
            let templateList = {
                headers: [],
                records: []
            };
            templateList.headers.push({
                text: 'PDF Template Name',
                field: 'MAC_FILE_NAME',
                width: 700,
            });
            this.surveysExist = false;
            if (response.status === 'success' && response.data) {
                for (let i in response.data) {
                    if (i === 'length') continue;
                    let tmp = library.cloneObj(response.data[i]);
                    tmp['rowID'] = response.data[i].ATTACH_ID;
                    tmp['REAL_MAC_FILE_NAME'] = library.cloneObj(tmp['MAC_FILE_NAME']);
                    if (response.data[i].IS_SURVEY) {
                        this.surveysExist = true;
                        tmp['MAC_FILE_NAME'] = '* ' + tmp['REAL_MAC_FILE_NAME'];
                    }
                    templateList.records.push(tmp);
                }
            }
            this.hideLoadingIndicator();
            this.templateList = library.cloneObj(templateList);
        },
        disableButtons() {
            if (this.controls) {
                this.controls['COPY_TEMPLATE'].disabled = true;
                this.controls['EDIT_TEMPLATE'].disabled = true;
                this.controls['DELETE_TEMPLATE'].disabled = true;
                this.controls['DOWNLOAD_TEMPLATE'].disabled = true;
                if (this.selectedItems.length === 1) {
                    this.controls['COPY_TEMPLATE'].disabled = false;
                    this.controls['EDIT_TEMPLATE'].disabled = false;
                    this.controls['DELETE_TEMPLATE'].disabled = false;
                    this.controls['DOWNLOAD_TEMPLATE'].disabled = false;
                    if (this.selectedItemsFullData && this.selectedItemsFullData[0] && this.selectedItemsFullData[0].IS_SURVEY) {
                        this.controls['DOWNLOAD_TEMPLATE'].disabled = true;
                    }
                }
                if (this.selectedItems.length >= 1) {
                    this.controls['DELETE_TEMPLATE'].disabled = false;
                }
            }
        },
        async new() {
            let response = await actionStore.openPdf({
                mode: 'editor',
                isNew: true,
            });
            if (response && response.funcPreSuccess && response.funcPreSuccess.templateHash) {
                this.getList();
            }
        },
        async dblClickFnc(tmpId, selectedItem) {
            this.edit(selectedItem);
        },
        async edit(tmpSelectedItem) {
            let selectedItem = this.selectedItems;
            let selectedItemsFullData = this.selectedItemsFullData;
            if (tmpSelectedItem && !(tmpSelectedItem instanceof PointerEvent)) {
                selectedItem = [tmpSelectedItem];
                selectedItemsFullData = [tmpSelectedItem];
            }
            if (selectedItem.length === 1) {
                if (selectedItemsFullData[0].IS_SURVEY) {
                    if (typeof doInternalAction === 'function') {
                        doInternalAction('edit', [selectedItemsFullData[0].ATTACH_ID]);
                    }
                } else {
                    await actionStore.openPdf({
                        mode: 'editor',
                        fileName: selectedItemsFullData[0].REAL_MAC_FILE_NAME,
                        isNew: false,
                        attachID: selectedItemsFullData[0].ATTACH_ID,
                        templateHash: selectedItemsFullData[0].ATTACH_FILE_HASH,
                    });
                    this.getList();
                }
            }
        },
        async delete() {
            if (this.selectedItems.length) {
                this.showLoadingIndicator();
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE_THE_TITLE');
                let titleWarning = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                let templateName = this.selectedItemsFullData[0].REAL_MAC_FILE_NAME;
                let attachIDs = [];
                let surveyIDs = [];
                let surveyNames = [];
                let usedInLdf = [];
                for (let i in this.selectedItemsFullData) {
                    if (i === 'length') continue;
                    if (typeof this.selectedItemsFullData[i].USED_IN_LDF !== 'undefined' && this.selectedItemsFullData[i].USED_IN_LDF.length) {
                        usedInLdf.push(...this.selectedItemsFullData[i].USED_IN_LDF);
                    }
                    if (this.selectedItemsFullData[i].IS_SURVEY) {
                        surveyIDs.push(this.selectedItemsFullData[i].ATTACH_ID);
                        surveyNames.push(this.selectedItemsFullData[i].REAL_MAC_FILE_NAME);
                    } else {
                        attachIDs.push(this.selectedItemsFullData[i].ATTACH_ID);
                    }
                }
                if (usedInLdf.length) {
                    usedInLdf.sort();
                    let message = await ddStore.getAlias('ADMIN_OPTIONS', 'PDFTEMPLATES_ERR_LDF_EXIST', usedInLdf.join('<br/>'));
                    this.hideLoadingIndicator();
                    library.showDialog(message, false, false, { title: titleWarning, showAsAlert: true });
                } else {
                    let message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE_THE', ' ', templateName);
                    if ((attachIDs.length + surveyIDs.length) > 1) {
                        message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_MULTIDELETE', 'templates');
                    }
                    this.hideLoadingIndicator();
                    library.showDialog(message, async () => {
                        this.showLoadingIndicator();
                        await this.sDs.post('sds_deletePdfTemplate', attachIDs);
                        this.hideLoadingIndicator();
                        if (surveyIDs.length) {
                            if (typeof doInternalAction === 'function') {
                                doInternalAction('delete', surveyIDs, surveyNames);
                            }
                        } else {
                            this.getList();
                        }
                    }, false, { title: title });
                }
            }
        },
        async copy() {
            if (this.selectedItems.length === 1) {
                if (this.selectedItemsFullData[0].IS_SURVEY) {
                    if (typeof doInternalAction === 'function') {
                        doInternalAction('copy', [this.selectedItemsFullData[0].ATTACH_ID]);
                    }
                } else {
                    this.showLoadingIndicator();
                    await this.sDs.post('sds_copyPdfTemplate', this.selectedItemsFullData[0].ATTACH_ID, { sDsParams: { force: true } });
                    this.hideLoadingIndicator();
                    this.getList();
                }
            }
        },
        download() {
            if (this.selectedItems.length === 1 && !this.selectedItemsFullData[0].IS_SURVEY) {
                let link = document.createElement("a");
                link.download = this.selectedItemsFullData[0].REAL_MAC_FILE_NAME;
                let href = this.selectedItemsFullData[0].ATTACH_FILE_URL;
                if (href) {
                    href += '&d=1';
                    link.href = href;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }
    }
};

componentStore.initComponent(pdfTemplateManagerCmp, pdfTemplateManagerConfig);
export { pdfTemplateManagerCmp, pdfTemplateManagerConfig };
export default pdfTemplateManagerCmp;

</script>

<style scoped>
.pdf-template-manager {
    padding: 5px;
    width: 800px;
    margin: 0 auto;
}
.template-controls {
    padding: 5px;
}
.template-controls .control {
    margin-right: 5px;
}
.template-controls .control:last-child {
    margin-right: 0px;
}
.left-controls {
    float: left;
}
.right-controls {
    float: right;
}
.left-controls > div, .right-controls > div {
    display: inline-block;
}
.clearfix {
    clear: both;
}
:deep(.e-headerchkcelldiv) {
    padding-left: 2px !important;
}
:deep(.pdf-template-manager .e-columnheader  *) {
    background-color: #cfd8dc !important;
    color: black !important;
    border-color: #757575 !important;
}
:deep(.pdf-template-manager .e-headercelldiv) {
    text-align: left !important;
}
:deep(.pdf-template-manager .e-gridheader) {
    background-color: #cfd8dc !important;
}
</style>
